module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex w-100 choose"
  }, [_c('v-btn', {
    staticClass: "auth-default-btn ma-0",
    class: {
      active: _vm.accountCategory == 'listener'
    },
    on: {
      "click": function($event) {
        _vm.chooseAccount('listener')
      }
    }
  }, [_vm._v("\n      Listener\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-default-btn ma-0",
    class: {
      active: _vm.accountCategory == 'creator'
    },
    on: {
      "click": function($event) {
        _vm.chooseAccount('creator')
      }
    }
  }, [_vm._v("\n      Creator\n    ")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n    Next\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "login mt-5"
  }, [_vm._v("Already have an account?")]), _vm._v(" "), _c('router-link', {
    staticClass: "d-flex justify-center mt-4",
    attrs: {
      "to": "/login"
    }
  }, [_c('v-btn', {
    staticClass: "auth-default-btn max-w145"
  }, [_vm._v(" Login ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d814eb2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/onboarding/chooseAccount.vue
// module id = 1820
// module chunks = 180